// Copyright (c) Siemens AG 2026 ALL RIGHTS RESERVED.
//
// mySiESTA

import RemoteModal from './remote_modal'

export default class LdapUserModal extends RemoteModal {
  constructor(options = {}) {
    super('/ldap_users', options.closeAfterResolve)

    if (options.onlyLdap) {
      this.queryParams.only_ldap = true
    }

    if (options.createLdapUsers) {
      this.createLdapUsers = true
    }
  }

  createUser(userParams) {
    return up.request(this.url, {
      method: 'POST',
      params: {
        email: userParams.email,
        given_name: userParams.given_name,
        surname: userParams.surname,
        gid: userParams.uid,
        uid: userParams.uid,
        org_code: userParams.org_code,
      },
    }).catch(function(error) {
      console.error('The request failed', error)
    })
  }

  onSelectButtonClick(e) {
    e.preventDefault()

    const element = e.target
    const modal = this

    const userNotInDatabase = this.createLdapUsers && element.getAttribute('ldap-user') === 'true'

    if (userNotInDatabase) {
      const userParams = JSON.parse(element.dataset.user)

      this.createUser(userParams).then(function(response) {
        const jsonResponse = JSON.parse(response.text)
        modal.returnWithValue(jsonResponse.user)
      })
    } else {
      const user = JSON.parse(element.dataset.user)
      modal.returnWithValue(user)
    }

    return false
  }

  onOpened(modal) {
    return up.on(modal, 'click', '.ldap-user--select', (e) => {
      return this.onSelectButtonClick(e)
    })
  }
}
